import {
  ValidateProcessSettingsDocument,
  ValidateProcessSettingsMutation,
  ValidateProcessSettingsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useValidateProcessSettings = () => {
  const [ValidateProcessSettings, { loading }] = useMutation(ValidateProcessSettingsDocument, {
    extractorFn: (data: ValidateProcessSettingsMutation) =>
      data.processesMutations.validateSettingsProcessesProcess,
  })

  return {
    loading,
    validateProcessSettings(variables: ValidateProcessSettingsMutationVariables) {
      return ValidateProcessSettings({
        variables,
        awaitRefetchQueries: true,
      })
    },
  }
}
